import { createContext, useContext, useMemo, useRef, useState } from 'react';
import ConfirmTemplate from './ConfirmTemplate';
import MessageTemplate from './MessageTemplate';

const TemplateContext = createContext();

export function useTemplate() {
    return useContext(TemplateContext);
}

function TemplateProvider({ children }) {
    const suggestRef = useRef();
    const [message, setMessage] = useState(null);
    const [confirm, setConfirm] = useState(null);
    const [templateLoading, setTemplateLoading] = useState(false);
    const [showModal, setShowModal] = useState({
        type: '',
        data: null
    });

    const value = useMemo(() => {
        // --Handler to open modal
        const openModal = (type, data) => {
            setShowModal({
                type,
                data
            });
        };

        // --Handler to close modal
        const closeModal = () => {
            setShowModal({
                type: '',
                data: null
            });
        };

        return {
            suggestRef,
            message,
            setMessage,
            confirm,
            setConfirm,
            // when textAction button click and until textAction operation success or fail
            templateLoading,
            setTemplateLoading,
            openModal,
            closeModal,
            modalType: showModal?.type,
            modalData: showModal?.data
        };
    }, [message, confirm, templateLoading, showModal?.type, showModal?.data]);

    return (
        <TemplateContext.Provider value={value}>
            {children}
            <MessageTemplate message={message} setMessage={setMessage} />
            <ConfirmTemplate confirm={confirm} setConfirm={setConfirm} loading={templateLoading} />
        </TemplateContext.Provider>
    );
}

export default TemplateProvider;
